const categoryData = {
  category: [
    {
      id: 1,
      title: "International",
    },
    {
      id: 2,
      title: "Bangladesh",
    },
    {
      id: 3,
      title: "Business",
    },
    {
      id: 4,
      title: "Entertainment",
    },
    {
      id: 5,
      title: "Environment",
    },
    {
      id: 6,
      title: "Sports",
    },
    {
      id: 7,
      title: "Tech",
    },
  ],
  subCategory: [
    {
      id: 1,
      title: "Politics",
    },
    {
      id: 2,
      title: "Accident",
    },
    {
      id: 3,
      title: "Crime",
    },
    {
      id: 4,
      title: "Asia",
    },
    {
      id: 5,
      title: "Europe",
    },
    {
      id: 6,
      title: "America",
    },

    {
      id: 7,
      title: "Cricket",
    },
    {
      id: 8,
      title: "Football",
    },
    {
      id: 9,
      title: "Local Sports",
    },
    {
      id: 10,
      title: "Local Business",
    },
    {
      id: 11,
      title: "Global Business",
    },
    {
      id: 12,
      title: "Gadgets & Apps",
    },
    {
      id: 13,
      title: "Social Media",
    },
    {
      id: 14,
      title: "It",
    },
    {
      id: 15,
      title: "Movies",
    },
    {
      id: 16,
      title: "Music",
    },
    {
      id: 17,
      title: "Television",
    },
    {
      id: 18,
      title: "Climate",
    },
    {
      id: 19,
      title: "Pollution",
    },
  ],
};

export default categoryData;
